// Ticket 133 — Hotwire Native bridge.
//
// Laat een webpagina native functies aanroepen (camera/scanner, notificaties,
// gezondheidsdata). Zonder native schil zijn de aanroepen no-ops, zodat dezelfde
// pagina in de browser gewoon blijft werken; waar mogelijk is er een web-fallback
// in de component zelf (zie wake_lock_controller).
//
// De native schil (tickets 134/135) registreert per component-naam een handler:
// iOS via WKScriptMessageHandler, Android via een JavascriptInterface.

export function isNativeApp() {
  return /Hotwire Native|Turbo Native/.test(navigator.userAgent);
}

export function nativePlatform() {
  if (!isNativeApp()) return null;
  const ua = navigator.userAgent;
  if (/iOS/.test(ua)) return "ios";
  if (/Android/.test(ua)) return "android";
  return null;
}

// Stuur een bericht naar de native schil. Geeft true terug als het is afgeleverd.
export function postToNative(component, event, data = {}) {
  const message = { component, event, data };
  const platform = nativePlatform();
  try {
    if (platform === "ios" && window.webkit?.messageHandlers?.[component]) {
      window.webkit.messageHandlers[component].postMessage(message);
      return true;
    }
    if (platform === "android" && window.NativeBridge?.postMessage) {
      window.NativeBridge.postMessage(JSON.stringify(message));
      return true;
    }
  } catch (e) {
    console.warn("native bridge: versturen mislukt", e);
  }
  return false;
}

// De native schil praat terug naar de pagina door een DOM-event te dispatchen:
//   window.dispatchEvent(new CustomEvent("native:scanner", { detail: {...} }))
// Componenten luisteren daarop via deze helper.
export function onNativeMessage(component, handler) {
  const listener = (e) => handler(e.detail || {});
  window.addEventListener(`native:${component}`, listener);
  return () => window.removeEventListener(`native:${component}`, listener);
}
